import React from 'react';
import { BrowserRouter as Router, Link, useHistory , Route} from 'react-router-dom';
import './footer.styles.scss';

import Logo from '../../assets/voltex_logo.png';
import Voucher from '../../pages/homepage/homepage.component';
import Dashboard from '../../pages/dashboard/dashboard.component';
import pdf_path from '../../assets/SME-UPS-Campaign-Terms_and_Conditions.pdf';
// import pdf_path1 from '../../assets/UPS-Campiaign-Terms-Conditions.pdf';
// import pdf_path2 from '../../assets/UPS-Campiaign-Terms-Conditions-AX.pdf';

const Footer = ({ currentUser, hidden }) => {

    const history = useHistory();

    return(
    <div className="footer">
        <div className="options">
            {/* <p><b>Terms and Conditions</b>&nbsp; &nbsp; &nbsp;<a href={pdf_path} target="_blank" without="true" rel='noopener noreferrer'>Home Loans Terms and Conditions</a>&nbsp; &nbsp; &nbsp;<a href={pdf_path1} target="_blank" without="true" rel='noopener noreferrer'> Card Issuing - UPS Terms and Conditions(E)</a>&nbsp; &nbsp; &nbsp;<a href={pdf_path2} target="_blank" without="true" rel='noopener noreferrer'>Card Issuing - UPS Terms and Conditions(A)</a>  */}
            <p><b>Terms and Conditions</b>&nbsp; &nbsp; &nbsp;<a href={pdf_path} target="_blank" without="true" rel='noopener noreferrer'>SME Terms and Conditions</a>&nbsp; &nbsp; &nbsp;
           <b>Support Contact Number: </b>  &nbsp; Elsabe Van Den Berg: <a href="tel:0118642090"> 011 864 2090</a> &nbsp; &nbsp; &nbsp; Kelly Swartz: <a href="tel:0768317903"> 076 831 7903</a> &nbsp; &nbsp; &nbsp; &nbsp; Email: <a href="mailto:ups@voltex.co.za"> ups@voltex.co.za</a> </p> 
            
        </div>
    </div>
    )
}

export default Footer;